import React from 'react'
import { getUserDetails } from '../Auth/AuthUtil'
import DoshaChart from './Chart'
import { useEffect, useState } from 'react'
import { Button } from '@mui/material'
import goalsettingimg from '../Assets/images/goal setting.png'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import cautionimg from '../Assets/images/Caution icon 1.png'
import "slick-carousel/slick/slick-theme.css";
import fibpro from '../Assets/images/flbpro.png'
import bspro from '../Assets/images/bspro.png'
import WellnessStore from '../DataRepo/WellnessStore'
import { useNavigate } from 'react-router-dom'
import leftvec from '../Assets/images/left vector.png';
import rightvec from '../Assets/images/right vector.png';
import yogalandingimg from '../Assets/images/Yoga_Landingpage.png'
import pranayamalandingimg from '../Assets/images/Pranayama.png'
import meditationlandingimg from '../Assets/images/MeditationL.png'
import { profileModel } from '../Axios/AxiosConfig'
import bookconsultationvector from '../Assets/images/book_cons_vector.png'
import doctorvectorimgcard from '../Assets/images/doctor_card_vector.png'
import ShopStore from '../DataRepo/ShopStore'
import AppointmentStore from '../DataRepo/AppointmentStore'
import videoCallgrn from '../Assets/images/Video Call Orange Color.png'
import audiocallgrn from '../Assets/images/Call Icon Orange Color.png'
import calendaicon from '../Assets/images/Calender.png'
import clock from '../Assets/images/clock.png'
import lockimg from '../Assets/images/lock_icon.png'
import Dietsampleimg1 from '../Assets/images/D-1.png'
import Dietsampleimg2 from '../Assets/images/D-2.png'
import Dietsampleimg3 from '../Assets/images/D-3.png'
import Dietsampleimg4 from '../Assets/images/D-4.png'
import GoalsStore from '../DataRepo/GoalsStore'
import SubscriptionStore from '../DataRepo/SubscriptionStore'
import HealthScoreChart from '../Goals/HealthChart'
import ActivityTimeline from './ActivityTimeline'
import bugspeaksimg from '../Assets/images/bugspeaks[2].png'
import microbiomeimg from '../Assets/images/microbiome[1].png'

function HomePage() {

    const userDetails = getUserDetails()

    const { getTopProducts, Top_Products } = ShopStore();

    const { getGoal, Goals, isGoalsLoading, error } = GoalsStore();

    const { Subscriptiondetails, Subscriptiondetailsloading, getSubscriptiondetails, isSubscribed } = SubscriptionStore()

    const { Appointments, isAppointmentsLoading, getAppointments } = AppointmentStore()

    const [isprofileloading, setprofileloading] = useState(true)

    const [ProfileData, setProfileData] = useState([])

    const { Diets, getDiet, isDietLoading, getRecipes, Recipes, isRecipeLoading, Articles, getArticles, isArticlesLoading, Selected_Wellness, getSelected_Wellness } = WellnessStore();

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
    };

    const [currentIndex, setCurrentIndex] = useState(0);

    const [currentRindex, setRindex] = useState(0);

    const navigate = useNavigate()

    useEffect(() => {
        getDiet()
        getGoal()
        getArticles()
    }, [])

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % Diets?.Suitable?.length);
        }, 3000);

        return () => clearInterval(intervalId);
    }, [Diets?.Suitable?.length]);


    const getProfile = async (id) => {
        try {
            let res = await profileModel.get(`/Profile/${id}`)
            if (res.status === 200) {
                const profile = res?.data
                setProfileData(profile)
                setprofileloading(false)
            }
        }
        catch (err) {
            console.log(err?.response?.data)
        }
    }

    useEffect(() => {
        const intervalId = setInterval(() => {
            setRindex((prevIndex) => (prevIndex + 1) % Recipes?.length);
        }, 3000);

        return () => clearInterval(intervalId);
    }, [Recipes?.length]);

    useEffect(() => {
        getTopProducts()
        getSubscriptiondetails()
        getProfile(userDetails?.UID)
        getAppointments(userDetails?.UID)
    }, [])



    const [currentTestKitIndex, setCurrenttTestKitIndex] = useState(0);


    const landingimg = [
        // {
        //     img: bugspeaksimg,
        //     id: "9545745",
        // },
        {
            img: microbiomeimg,
            id: "9545746"
        },
    ]

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrenttTestKitIndex((prevIndex) =>
                prevIndex === landingimg.length - 1 ? 0 : prevIndex + 1
            );
        }, 3000);
        return () => clearInterval(interval);
    }, [landingimg.length]);


    const testKitSlider = [
        {
            id: fibpro,
            title: 'Track your Glucose effortlessly with our user-friendly CGM',
            description: 'Free style libre pro',
            code: '9545784',
        },
        {
            id: bspro,
            title: 'Discover Your Health Answers with our innovative kit!',
            description: 'BugSpeaks',
            code: '9545783',
        }
    ];

    useEffect(() => {
        if (Recipes.length === 0) {
            getRecipes()
        }
    }, [])

    const filterAppointments = Appointments?.filter(e => e.appointment_status === 'upcoming' || e.appointment_status === 'confirmed').sort((a, b) => {
        const dateA = a?.timestamp ? new Date(Number(a?.timestamp)) : new Date(0);
        const dateB = b?.timestamp ? new Date(Number(b?.timestamp)) : new Date(0);
        return dateB - dateA;
    });

    const DietSampleImages = [Dietsampleimg1, Dietsampleimg2, Dietsampleimg3, Dietsampleimg4]

    const wellnessItems = [
        {
            "name": "Energy & Weight Issues",
            "description": "For those feeling tired, sluggish, or struggling with weight",
            "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Energy+%26+Weight+Issues.png",
            "selected": false,
            "sub_categories": [
                "Fatigue & Low Energy",
                "Unexplained Weight Gain/Loss",
                "Blood Sugar Imbalances (Pre-diabetes, Diabetes)",
                "Thyroid Issues (Hypothyroidism, Hyperthyroidism)",
                "Cravings & Emotional Eating",
                "Water Retention & Swelling",
                "Slow Digestion & Weak Metabolism (Agni Imbalance)"
            ]
        },
        {
            "name": "Gut & Digestive Wellness",
            "description": "For those with stomach discomfort, bloating, or irregular digestion",
            "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Gut+%26+Digestive+Health.png",
            "selected": false,
            "sub_categories": [
                "Gas, Bloating & Indigestion",
                "Acid Reflux & Heartburn",
                "Constipation or Diarrhea",
                "Gut Microbiome Imbalance",
                "Food Sensitivities & Intolerances",
                "Irritable Bowel Syndrome (IBS) & Gut Sensitivity (gut sensitivity, Gut Irritation)",
                "Liver Health & Detox Issues (Fatty Liver, Toxins Overload)"
            ]
        },
        {
            "name": "Stress, Sleep & Mental Wellness",
            "description": "For those struggling with stress, sleep, and emotional balance",
            "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Stress%2C+Sleep+%26++Mental+Well-Being.png",
            "selected": false,
            "sub_categories": [
                "Chronic Stress & Anxiety",
                "Sleep Disorders (Insomnia, Poor Sleep Quality)",
                "Brain Fog & Lack of Focus",
                "Low Mood & Emotional Imbalances",
                "Headaches & Migraines",
                "Overthinking & Racing Thoughts",
                "Dizziness & Lightheadedness"
            ]
        },
        {
            "name": "Hormonal, Men & Women's Wellness",
            "description": "For hormone-related issues, menstrual & reproductive health",
            "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Hormonal%2C+Men+%26+Women%E2%80%99s++Wellness.png",
            "selected": false,
            "sub_categories": [
                "PCOS & Irregular Periods",
                "Menstrual Cramps & PMS",
                "Menopause Symptoms (Hot Flashes, Mood Swings)",
                "Thyroid Issues",
                "Low Libido & Reproductive Health",
                "Hormonal Acne & Skin Issues",
                "Breast Tenderness & Fibrocystic Breasts"
            ]
        },
        {
            "name": "Joint & Muscle Wellness",
            "description": "For those with body aches, joint pain, or chronic inflammation",
            "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Joint+%26+Muscle+Wellness.png",
            "selected": false,
            "sub_categories": [
                "Joint Pain & Stiffness",
                "Muscle Aches & Fatigue",
                "Chronic Inflammation",
                "Back, Neck & Shoulder Pain",
                "Tingling & Numbness in Hands/Feet (Circulation & Nerve Issues)",
                "Autoimmune-related symptoms"
            ]
        },
        {
            "name": "Skin and hair Wellness",
            "description": "For those dealing with frequent infections, allergies, skin or hair problems",
            "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Skin+%26+Hair+Health.png",
            "selected": false,
            "sub_categories": [
                "Seasonal & Food Allergies",
                "Skin Conditions (Eczema, Psoriasis, Rashes)",
                "Hair Fall & Premature Graying",
                "Allergies & Skin Sensitivities",
                "Frequent Colds, Cough, & Weak Immunity",
                "Chronic Sinus Issues & Respiratory Issues",
                "Dust Allergy"
            ]
        },

        {
            "name": "Respiratory & Immune Wellness",
            "description": "For those who frequently get sick, struggle with allergies or have breathing problems",
            "imageUrl": "https://aiwellassets.s3.ap-south-1.amazonaws.com/asset/Corporate+wellness+flow+vector/Respiratory+%26+Immune+Health.png",
            "selected": false,
            "sub_categories": [
                "Common Cold (Runny Nose & Sneezing)",
                "Asthma (Breathing Trouble & Wheezing)",
                "Bronchitis (Persistent Cough & Mucus)",
                "Sinusitis (Blocked Nose & Headache)",
                "Pneumonia (Severe Cough & Chest Pain)",
                "Allergies (Sneezing & Itchy Eyes)",
            ]
        }
    ]

    const handleNavigateToArticle = (articleUrl) => {
        navigate("/ViewArticle", { state: { url: articleUrl } });
    };


    return <div className='Homepage-main-screen'>
        <div className='Homepage-head-section'>

            {!isprofileloading &&
                <p>Hello, {ProfileData?.firstname?.trim() ? ProfileData.firstname : "Guest"}. Have a Nice Day!</p>
            }

            {/* 
            {
                filterAppointments.length === 0 ?
                    <>
                        {Goals != null ?
                            < div
                                className="Goal-main-page-card flex flex-row items-center justify-between mt-2 relative"
                                style={{ marginTop: "1rem", }}
                            >
                                <div
                                    style={{
                                        flex: "0.5",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        // justifyContent: "center",
                                    }}
                                >
                                    <p>Goal</p>

                                    <p>
                                        Discover steps to restore<br /> harmony & achieve balance
                                    </p>

                                    <div style={{ width: "100%", maxWidth: "200px" }}>
                                        <Button
                                            style={{
                                                width: "100%",
                                                textTransform: "none",
                                                backgroundColor: "#DA6E0B",
                                                border: "none",
                                                color: "#fdfdfd",
                                                borderRadius: "5px",
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                padding: "10px",
                                            }}
                                            onClick={() => {
                                                navigate("/GoalsResult");
                                            }}
                                        >
                                            <p className='appointmentbooknowbtn'>View Goal</p>
                                        </Button>
                                    </div>

                                </div>

                                <div
                                    className="Goal-main-page-card-wellness-img"
                                    style={{
                                        flex: "0.3",
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "1rem",
                                        // width:"20rem",
                                        paddingBottom: "0",
                                        justifyContent: "center",
                                        position: "relative",
                                    }}
                                >
                                    <HealthScoreChart percentage={Goals?.Total} homepage={true} />
                                </div>

                            </div> :
                            < div
                                className="Goal-main-page-card flex flex-row items-center justify-between mt-2 relative"
                                style={{ marginTop: "1rem", }}
                            >
                                <div
                                    style={{
                                        flex: "0.5",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <p style={{ textAlign: "center" }}>Schedule a Teleconsultation</p>

                                    <p style={{ textAlign: "center" }}>
                                        To make your health journey much easier
                                    </p>

                                    <div style={{ width: "100%", maxWidth: "200px" }}>
                                        <Button
                                            style={{
                                                width: "100%",
                                                textTransform: "none",
                                                backgroundColor: "#DA6E0B",
                                                border: "none",
                                                color: "#fdfdfd",
                                                borderRadius: "5px",
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                padding: "10px",
                                            }}
                                            onClick={() => {
                                                navigate("/DoctorProfiles");
                                            }}
                                        >
                                            <p className='appointmentbooknowbtn'>Book an Appointment</p>
                                        </Button>
                                    </div>

                                </div>

                                <div
                                    className="Goal-main-page-card-wellness-img"
                                    style={{
                                        flex: "0.3",
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "1rem",
                                        paddingBottom: "0",
                                        justifyContent: "center",
                                        position: "relative",
                                    }}
                                >
                                    <img
                                        src={bookconsultationvector}
                                        alt="Consultation"
                                        style={{
                                            position: "absolute",
                                            top: "-20px",
                                            maxWidth: "100%",
                                            transform: "translateY(-50%)",
                                        }}
                                    />
                                </div>

                            </div>
                        }
                    </>
                    :
                    <div className="Homepage-Appointments-container" style={{ marginTop: "1rem", }}>
                        <div className='All-appointments-container'>
                            <p className='uptitile'>Upcoming Appointment</p>
                            <div className='Appointments-container'
                                onClick={() => {
                                    navigate(`/Appointment?id=${filterAppointments[0].Appointment_id}&doc_id=${filterAppointments[0].doctor_uid}`)
                                }}>
                                <div>
                                    <div>
                                        <img src={filterAppointments[0]?.doctor_photo}></img>
                                    </div>
                                    <div>
                                        <p>{filterAppointments[0]?.doctor_name}</p>
                                        <p>{filterAppointments[0]?.doctor_speciality}</p>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <img src={calendaicon} />
                                        <p>{filterAppointments[0]?.appointment_date?.split('-')?.reverse()?.join('-')}</p>
                                    </div>
                                    <div>
                                        <img src={clock} />
                                        <p>{filterAppointments[0]?.appointment_time}</p>
                                    </div>
                                    <div>
                                        <img src={filterAppointments[0]?.consultation_type === "Video" ? videoCallgrn : audiocallgrn} />
                                        <p>{filterAppointments[0]?.consultation_type} Consultation</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            } */}

            <div
                className="Homepage-Appointments-container flex justify-between items-center px-[3.75rem] mt-4 h-full"
            >
                <div className="landingtextcardiv flex flex-col justify-between h-full p-4 rounded-md flex-1 gap-5">

                    <p className="text-xl font-medium leading-relaxed">
                        Enhance your wellness through our <br />
                        gut microbiome test for a tailored diet plan
                    </p>

                    <div className="" style={{ marginTop: 'auto' }}>
                        <Button
                            style={{
                                textTransform: "none",
                                backgroundColor: "#DA6E0B",
                                border: "none",
                                color: "#fdfdfd",
                                borderRadius: "5px",
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                fontSize: "14px",
                                padding: "8px 3rem",
                            }}
                            onClick={() => {
                                if (landingimg[currentTestKitIndex]) {
                                    navigate(`/TestKitPage?id=${landingimg[currentTestKitIndex]?.id}`);
                                }
                            }}
                        >
                            Explore
                        </Button>
                    </div>
                </div>

                <div className="landingtextcardimg ml-6">
                    <img
                        src={landingimg[currentTestKitIndex]?.img}
                        alt="Test Kit"
                        className="max-h-full object-contain"
                    />
                </div>
            </div>


            <ActivityTimeline />

            {Diets.length === 0 || Recipes.length === 0 ?
                <div className='Unlockdiet mt-5'>

                    <div>
                        <img src={lockimg}></img>
                    </div>

                    <div style={{ width: "100%", maxWidth: "300px" }}>
                        <Button
                            style={{
                                width: "100%",
                                textTransform: "none",
                                backgroundColor: "#DA6E0B",
                                border: "none",
                                color: "#fdfdfd",
                                borderRadius: "5px",
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                fontSize: "14px",
                                padding: "10px",
                            }}

                            onClick={() => {
                                {
                                    isSubscribed ?
                                        filterAppointments.length === 0 ?
                                            navigate("/DoctorProfiles")
                                            : navigate(`/Appointment?id=${filterAppointments[0]?.Appointment_id}&doc_id=${filterAppointments[0]?.doctor_uid}`)
                                        : navigate("/PackageCheckout")
                                }
                            }}

                        >
                            <p className='appointmentbooknowbtn'>
                                {
                                    isSubscribed ?
                                        filterAppointments.length === 0 ?
                                            "Book your consultation"
                                            : "Complete your consultation"
                                        : 'Purchase our Wellness Package'
                                }
                            </p>

                        </Button>
                    </div>

                    <p>To get personalized Diet & Recipes</p>

                    <div className="circle-container">
                        {DietSampleImages.map((image, index) => (
                            <div key={index} className="circle" style={{ backgroundImage: `url(${image})` }}></div>
                        ))}
                    </div>

                </div> : <></>
            }

            <div className='mt-5 Practices-section'>
                <div>
                    <img src={leftvec} alt="Left Arrow" />
                    <p>Harmony Within</p>
                    <img src={rightvec} alt="Right Arrow" />
                </div>
                <div className='Practices-main-content-section'>
                    <div>
                        <div onClick={() => {
                            navigate('/Yogas')
                        }}>

                            <img src={yogalandingimg}></img>
                            <p>Yoga</p>

                        </div>
                        <div onClick={() => {
                            navigate('/Pranayamas')
                        }}>
                            <img src={pranayamalandingimg}></img>
                            <p>Pranayama</p>
                        </div>
                        <div onClick={() => {
                            navigate('/Meditations')
                        }}>
                            <img src={meditationlandingimg}></img>
                            <p>Meditation</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='mt-5 Top-Products-landing-section'>

                <div>
                    <p>Top Products</p>
                    <p style={{ cursor: "pointer" }} onClick={() => {
                        navigate('/Products?type=All')
                    }}>View all</p>
                </div>

                <div>
                    {
                        Top_Products.map((e, i) => {
                            return <div className='Top-Products-landing-sectionpcard' style={{ cursor: "pointer" }} key={i} onClick={() => {
                                navigate(`/Product?id=${e?.id}`)
                            }}>
                                <div>
                                    <img src={e?.imgurl}></img>
                                </div>

                                <div>
                                    <p>{e?.name}</p>

                                    {e?.company_id != '1005' && <p>{e?.desc}</p>}

                                    <div className='Product-section-price-details'>
                                        <p>₹ {e?.price}</p>
                                    </div>

                                    {
                                        !e.onsale &&
                                        <div>
                                            <Button

                                                style={{
                                                    width: '100%',
                                                    textTransform: 'none',
                                                    backgroundColor: '#D9d9d9',
                                                    color: "#A5A39D",
                                                    border: 'none',
                                                    fontSize: "medium",
                                                    boxSizing: 'border-box',
                                                    borderRadius: "5px",
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontWeight: 500,
                                                    padding: "5px"
                                                }}
                                            >

                                                Out of Stock
                                            </Button>
                                        </div>
                                    }

                                </div>
                            </div>
                        })
                    }
                </div>
            </div>


            <div className='mt-5 Top-Products-landing-section'>

                <div>
                    <p>Articles</p>
                    <p style={{ cursor: "pointer" }} onClick={() => {
                        navigate('/Articles')
                    }}>View all</p>
                </div>

                <div>
                    {wellnessItems.map((category, index) => (
                        <div
                            key={index}
                            className={`WellnessCard 
                            articles-wellness-card
                            flex items-stretch h-full gap-5 w-full items-center p-2 border-2 rounded-lg cursor-pointer`}
                            style={category.selected ? { border: '2px solid #DA6E0B' } : { flexShrink: 0 }}
                            onClick={() => navigate("/Articles", { state: { categoryName: category.name } })
                            }
                        >
                            <div className={`WellnessImg`}>
                                <img src={category.imageUrl} alt={category.name} />
                            </div>

                            <p className='mt-2' style={{ whiteSpace: 'pre-line' }}>
                                {category.name}
                            </p>

                        </div>
                    ))}
                </div>

                {Articles?.length > 0 &&
                    <div className="list-of-articles grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2 gap-6 mt-5">
                        {Articles && Articles.length > 0 ? (
                            [...Articles]
                                .sort((a, b) => new Date(b.date) - new Date(a.date))
                                .slice(0, 2)
                                .map((e, i) => (
                                    <div
                                        key={i}
                                        onClick={() => { handleNavigateToArticle(e?.src) }}
                                        className="articles-card bg-white rounded-xl shadow-md overflow-hidden transition-transform transform hover:scale-105"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div className="h-30 w-full overflow-hidden">
                                            <img src={e?.image} alt={e?.title} className="object-contain h-full w-full" />
                                        </div>

                                        <div className="p-4">
                                            <p className="text-md text-[#3B362A]" style={{
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 500,
                                                color: "#3B362A"
                                            }}>{e?.title}</p>
                                        </div>
                                    </div>
                                ))
                        ) : (
                            <div className="col-span-full text-center text-gray-500">No Articles Found</div>
                        )}
                    </div>

                }

            </div>

            <div className='mt-5' style={{ display: "none" }}>
                <Slider {...settings}>
                    {testKitSlider.map(item => (
                        <div className='testkitslidecard flex flex-row'>
                            <div>
                                <img src={item.id}></img>
                            </div>
                            <div className='testkitslidecard-info'>
                                <p>{item.title}</p>
                                <div>
                                    <Button
                                        style={{
                                            width: '100%',
                                            textTransform: 'none',
                                            borderRadius: '0',
                                            backgroundColor: '#8CEB8C',
                                            color: '#3B362A',
                                            border: 'none',
                                            boxSizing: 'border-box',
                                            borderRadius: "5px",
                                            fontFamily: "'Poppins', sans-serif",
                                            fontWeight: 500,
                                            padding: "10px"
                                        }}

                                        onClick={() => {
                                            //   navigate('/SignUp')
                                        }
                                        }
                                    >
                                        Explore here
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>

            {/* <div className='mt-10'>
                <div className='Slot-errreponse'>
                    <div className='flex flex-col items-center'>
                        <img src={cautionimg}></img>
                        <p style={{ fontWeight: 500, fontSize: 'large' }}>Disclaimer</p>
                    </div>
                    <p>Recommendations are approved by our Ayurveda physician Dr.Prathiban. The assessment and suggestions provided here are for health and wellness purposes only. Please do not self-medicate. Consult an Ayurveda practitioner or medical professional for accurate guidance.</p>
                </div>
            </div> */}

        </div>
    </div >
}

export default HomePage